<dgx-components-grid-section [themeFlush]="true">
  <dgx-components-grid-container>
    <div *ngIf="articleList.length">
      <h3 class="section-title">
        {{ articlesTitle }} &lpar;{{ articleList.length }}&rpar;
      </h3>
      <dgx-components-article-list
        [articles]="articleList"
        [displayableItems]="displayableItems"
        [searchTerm]="searchTerm"
        data-testid="article-list"
      />
      <a
        *ngIf="viewMoreArticlesLink"
        [dgxNavigationLink]="viewMoreArticlesLink"
        class="view-more-link"
      >
        <dgx-components-button-text
          class="view-more-button"
          iconName="arrow-right"
        >
          {{ 'VIEW_MORE' | translate }}
        </dgx-components-button-text>
      </a>
    </div>
    <div *ngIf="videoList.length">
      <h3 class="section-title video-title">
        {{ videosTitle }} &lpar;{{ videoList.length }}&rpar;
      </h3>
      <ul class="video-list">
        <li
          *ngFor="
            let video of displayableItems
              ? (videoList | slice: 0 : displayableItems)
              : videoList
          "
          class="video-list__item mb-3"
        >
          <a
            [dgxNavigationLink]="video.navigationLink"
            class="video-list__video-link"
          >
            <dgx-components-youtube-player
              class="video-list__video video-embed-player"
              [video]="{
                id: video.videoId,
              }"
              class="video-list__video video-embed-player"
            ></dgx-components-youtube-player>

            <div class="video-list__content ml-4">
              <h5
                [searchTerm]="searchTerm"
                [text]="video.title"
                class="video-list__content-title mb-2"
                dgxTextHighlight
              >
                {{ video.title }}
              </h5>
              <p [searchTerm]="searchTerm" [text]="video.body" dgxTextHighlight>
                {{ video.body }}
              </p>
            </div>
          </a>
        </li>
      </ul>

      <a
        *ngIf="viewMoreVideosLink"
        [dgxNavigationLink]="viewMoreVideosLink"
        class="view-more-link"
      >
        <dgx-components-button-text
          class="view-more-button"
          iconName="arrow-right"
        >
          {{ 'VIEW_MORE' | translate }}
        </dgx-components-button-text>
      </a>
    </div>
  </dgx-components-grid-container>
</dgx-components-grid-section>
